import { TYPES } from 'action-types/ets';
import {
    IETSDetail, EmptyETSDetails, IUploadLogs,
    INftpBillableResponse
} from './models';

interface IAction {
    readonly type: string;
    readonly etsDetails: IETSDetail;
    readonly ets: any;
    readonly errors: string;
    readonly bulkUploadStatus: any;
    readonly bulkUploadLogs: IUploadLogs;
    readonly bulkDownloadString: any;
    readonly bulkDownloadLogs: any;
    readonly bulkDownloadFile: any;
    readonly bulkDownloadfilename: any;
    readonly bulkUploadExportResponse: any;
    readonly sendCreateSalesOrderImportResult: any;
    readonly nftpBillableResponse: INftpBillableResponse | null;
}
export interface IETSState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly isUploadDataError: boolean;
    readonly isUploadLoading: boolean;
    readonly detailsPendingError: string;
    readonly etsDetails: IETSDetail;
    readonly ets: any
    readonly bulkUploadStatus: any
    readonly bulkUploadLogs: IUploadLogs;
    readonly bulkDownloadLogs: any;
    readonly bulkDownloadString: any;
    readonly bulkDownloadFile: any;
    readonly bulkDownloadfilename: any;
    readonly isDownloadDataError  : boolean;
    readonly isDownloadLoading: boolean;
    readonly bulkUploadExportResponse: any;
    readonly sendCreateSalesOrderImportResult: any;
    readonly nftpBillableResponse: INftpBillableResponse | null;
    readonly isNftpBillableLoading: boolean;
}

export const defaultState: IETSState = {
    isFetchDataLoading: false,
    isFetchDataError: false,
    isUploadLoading: false,
    isUploadDataError: false,
    isDownloadDataError: false,
    isDownloadLoading: false,
    detailsPendingError: '',
    etsDetails: EmptyETSDetails,
    bulkUploadStatus: {},
    bulkDownloadString: '',
    bulkDownloadFile: null,
    bulkDownloadfilename: '',
    bulkUploadExportResponse: {},
    ets: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    bulkUploadLogs:  {
        page: 1,
        pageSize: 0,    
        data: [],
        totalCount: 0
    },
    bulkDownloadLogs:  {
        page: 1,
        pageSize: 0,    
        data: [],
        totalCount: 0
    },
    sendCreateSalesOrderImportResult: null,
    nftpBillableResponse: null,
    isNftpBillableLoading: false,
}

export const reducer = (state: IETSState = defaultState, action: IAction): IETSState => {
    switch (action.type) {
        case TYPES.RESET_ETS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                detailsPendingError: ''
            };
        case TYPES.RESET_ETS.FULFILLED:
            return {
                ...state,
                ets: defaultState.ets
            };
        case TYPES.FETCH_ETS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                ets: defaultState.ets
            };
        case TYPES.FETCH_ETS.FULFILLED:
            return {
                ...state,
                isFetchDataError: false,
                detailsPendingError: '',
                isFetchDataLoading: false,
                ets: action.ets && action.ets.result? action.ets: defaultState.ets
            };
        case TYPES.FETCH_ETS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_ETS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_ETS_DETAILS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                etsDetails: defaultState.etsDetails
            };
        case TYPES.FETCH_ETS_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                etsDetails: action.etsDetails || defaultState.etsDetails
            };
        case TYPES.FETCH_ETS_DETAILS.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };

        case TYPES.BULK_UPLOAD_ETS.PENDING:
            return {
                ...state,
                isUploadDataError: false,
                isUploadLoading: true,
                bulkUploadStatus: defaultState.bulkUploadStatus
            };
        case TYPES.BULK_UPLOAD_ETS.FULFILLED:
            return {
                ...state,
                isUploadLoading: false,
                isUploadDataError: false,
                bulkUploadStatus: action.bulkUploadStatus
            };
        case TYPES.BULK_UPLOAD_ETS.REJECTED:
            return {
                ...state,
                isUploadDataError: true,
                isUploadLoading: false,
                detailsPendingError: action.errors
            };
        
        case TYPES.BULK_UPLOAD_EXPORT.PENDING:
            return {
                ...state,
                isUploadDataError: false,
                isUploadLoading: true,
                bulkUploadExportResponse: defaultState.bulkUploadExportResponse
            };
        case TYPES.BULK_UPLOAD_EXPORT.FULFILLED:
            return {
                ...state,
                isUploadLoading: false,
                isUploadDataError: false,
                bulkUploadExportResponse: action.bulkUploadExportResponse
            };
        case TYPES.BULK_UPLOAD_EXPORT.REJECTED:
            return {
                ...state,
                isUploadDataError: true,
                isUploadLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.BULK_DOWNLOAD_ETS.PENDING:
            return {
                ...state,
                isUploadDataError: false,
                isDownloadLoading: true,
                bulkDownloadString: defaultState.bulkDownloadString
            };
        case TYPES.BULK_DOWNLOAD_ETS.FULFILLED:
            return {
                ...state,
                isDownloadLoading: false,
                isUploadDataError: false,
                bulkDownloadString: action.bulkDownloadString
            };
        case TYPES.BULK_DOWNLOAD_ETS.REJECTED:
            return {
                ...state,
                isUploadDataError: true,
                isDownloadLoading: false,
                detailsPendingError: action.errors
            };

        case TYPES.BULK_DOWNLOAD_ETS_FILE.PENDING:
            return {
                ...state,
                isDownloadDataError: false,
                isDownloadLoading: true,
                bulkDownloadFile: defaultState.bulkDownloadFile,
                bulkDownloadfilename: defaultState.bulkDownloadfilename
            };
        case TYPES.BULK_DOWNLOAD_ETS_FILE.FULFILLED:
            return {
                ...state,
                isDownloadLoading: false,
                isDownloadDataError: false,
                bulkDownloadFile: action.bulkDownloadFile,
                bulkDownloadfilename: action.bulkDownloadfilename
            };
        case TYPES.BULK_DOWNLOAD_ETS_FILE.REJECTED:
            return {
                ...state,
                isDownloadDataError: true,
                isDownloadLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_BULK_UPLOAD.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                bulkUploadLogs: defaultState.bulkUploadLogs
            };
        case TYPES.FETCH_BULK_UPLOAD.FULFILLED:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: false,
                bulkUploadLogs: action.bulkUploadLogs
            };
        case TYPES.FETCH_BULK_UPLOAD.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_DOWNLOAD_LOGS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                bulkDownloadLogs: defaultState.bulkDownloadLogs
            };
        case TYPES.FETCH_DOWNLOAD_LOGS.FULFILLED:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: false,
                bulkDownloadLogs: action.bulkDownloadLogs
            };
        case TYPES.FETCH_DOWNLOAD_LOGS.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_ETS_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.RESET_ETS_DETAILS:
            return {
                ...state,
                etsDetails: EmptyETSDetails,
            }
        case TYPES.RESET_DOWNLOAD:
                return {
                    ...state,
                    bulkDownloadFile: defaultState.bulkDownloadFile,
                    bulkDownloadfilename: defaultState.bulkDownloadfilename
                }
        case TYPES.SALES_ORDER_IMPORT.PENDING:
            return {
                ...state,
                sendCreateSalesOrderImportResult: null,
            };
        case TYPES.SALES_ORDER_IMPORT.FULFILLED:
            return {
                ...state,
                sendCreateSalesOrderImportResult: action.sendCreateSalesOrderImportResult
            };
        case TYPES.SALES_ORDER_IMPORT.REJECTED:
            return {
                ...state,
                sendCreateSalesOrderImportResult: action.errors
            };
         case TYPES.FETCH_NFTP_BILLABLE.PENDING:
            return {
                ...state,
                isNftpBillableLoading: true,
                nftpBillableResponse: null,
            };
        case TYPES.FETCH_NFTP_BILLABLE.FULFILLED:
            return {
                ...state,
                isNftpBillableLoading: false,
                nftpBillableResponse: action.nftpBillableResponse,
            };
        case TYPES.FETCH_NFTP_BILLABLE.REJECTED:
            return {
                ...state,
                isNftpBillableLoading: false,
                nftpBillableResponse: null,
            };

        default:
            return state;
    }
};
